import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment.prod';
import {
  SourceChannel,
  PublicationList,
  PublicationSave,
  ChannelList,
  PublicationRes,
  Requisition,
} from '../models/publicationmodel';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PublicationService {
  // baseUrl = environment.apiUrl;

  baseUrl = environment.publicationUrl;
  constructor(private http: HttpClient) {}

  getSourceChannel(companyHiringTypeId: number) {
    return this.http.get<SourceChannel>(this.baseUrl + 'getPrimarySourceList/' + companyHiringTypeId);
  }

  getpublicationList(postingId: number, companyHiringTypeId: number) {
    return this.http.get<PublicationList[]>(
      this.baseUrl + 'getPublicationList?postingId=' + postingId + '&companyHiringTypeId=' + companyHiringTypeId,
    );
  }

  getSecondarySourceList(sourceId) {
    return this.http.get<ChannelList[]>(this.baseUrl + 'getSecondarySourceList/' + sourceId);
  }

  savePublication(Object: PublicationSave, tabCategory): Observable<PublicationRes[]> {
    let params = new HttpParams();
    params = params.append('request', tabCategory[0]);
    const options = { headers: new HttpHeaders().set('Content-Type', 'application/json'), params: params };
    return this.http.post<PublicationRes[]>(
      this.baseUrl + 'saveandUpdatePublicationDeatilsnotindraft',
      Object,
      options,
    );
  }

  getRequisitionData(reqId): Observable<Requisition> {
    return this.http.get<Requisition>(this.baseUrl + 'getRequisition/' + reqId);
  }

  deletePublication(publicationId: number): Observable<PublicationRes> {
    const requestOptions: object = {
      responseType: 'text',
    };
    return this.http.post<PublicationRes>(this.baseUrl + 'deletePublication/' + publicationId, Object, requestOptions);
  }
}
